import React from "react";
import escapeRegExp from "lodash.escaperegexp";

interface IHighlightedProps {
  text: string;
  highlight: string;
  onClick: () => void;
}

const Highlighted = ({ text, highlight, onClick }: IHighlightedProps) => {
  if (!highlight.trim()) {
    return (
      <span className='s-results-link' onClick={onClick}>
        {text}
      </span>
    );
  }
  const regex = new RegExp(`(${escapeRegExp(highlight)})`, "gi");
  const parts = text.split(regex);
  return (
    <span className='s-results-link' onClick={onClick}>
      {parts
        .filter((part) => part)
        .map((part, i) =>
          regex.test(part) ? (
            <mark
              style={{ color: "#3D94F6", backgroundColor: "transparent" }}
              key={i}
            >
              {part}
            </mark>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
    </span>
  );
};

export default Highlighted;
